import React, { useState } from 'react';
import { sortBy, cloneDeep } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSyncAlt } from '@fortawesome/pro-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons';

import EnergyTracerTable from '../../tables';
import LinkCustomPlugTemplateModel from '../../modals/PlugCustomTemplateModals/LinkCustomPlugTemplateModal';
import { ApiServiceServerless } from '../../../xhr_libs';
import ConfirmationModal, { useConfirm } from '../../modals/ConfirmationModal';

const styles = {
  buttonIcon: {
    fontSize: '18px',
    lineHeight: 'inherit',
    color: 'var(--et_tab_grey)',
    cursor: 'pointer',
  },
  repullStyle: {
    fontSize: '18px',
    lineHeight: 'inherit',
    marginRight: '0.5em',
    color: 'var(--et_tab_grey)',
    cursor: 'pointer',
  },
  cancelStyle: {
    fontSize: '18px',
    marginLeft: '0.25em',
    paddingTop: '0.25em',
    lineHeight: 'inherit',
    color: 'red',
    cursor: 'pointer',
  },
};

export default function PlugCustomTemplateAccounts(props) {
  const {
    organizationId,
    localUtilityAccounts,
    setLocalUtilityAccounts,
    templates,
    showToast,
  } = props;

  const [showAddModal, setShowAddModal] = useState(false);
  const [addAccountId, setAddAccountId] = useState(null);
  const [confirmationModalProps, withConfirm] = useConfirm();
  const [confirmationModalProps2, withConfirm2] = useConfirm();

  const handleOpenAddModal = (utility_account_id) => {
    setShowAddModal(true);
    setAddAccountId(utility_account_id);
  };

  const handleOnHide = () => {
    setShowAddModal(false);
    setAddAccountId(null);
  };

  const handleUnlinkAccount = (utility_account_id) => {
    const msg = `Are you sure you want unlink this template from this account?`;

    withConfirm(msg, () => {
      unlinkAccount(utility_account_id);
    });
  };

  const unlinkAccount = (utility_account_id) => {
    ApiServiceServerless.delete(
      `/custom_templates/account/${utility_account_id}`,
      { authorization_id: organizationId }
    )
      .then(() => {
        setLocalUtilityAccounts((prev) =>
          prev.map((acc) => {
            if (acc.id !== utility_account_id) return acc;
            let new_acc = cloneDeep(acc);
            new_acc['utility_template'] = null;
            return new_acc;
          })
        );

        showToast('success', 'Success', 'Account template reset');
      })
      .catch((err) => {
        showToast('danger', 'Error', err);
        throw err;
      });
  };

  const handleRepullAccount = (utility_account_id) => {
    const msg = `Are you sure you want to refresh the data for this accounts?`;

    withConfirm2(msg, () => {
      repullAccount(utility_account_id);
    });
  };

  const repullAccount = (utility_account_id) => {
    ApiServiceServerless.get(
      `/custom_templates/account/${utility_account_id}`,
      { authorization_id: organizationId }
    )
      .then(() => {
        showToast(
          'success',
          'Success',
          'Repull in progress. Please allow a few minutes to complete'
        );
      })
      .catch((err) => {
        showToast('danger', 'Error', err);
        throw err;
      });
  };

  const tableColumns = [
    { dataField: 'account_number', text: 'Account Number' },
    { dataField: 'account_type', text: 'Account Type' },
    { dataField: 'utility_provider', text: 'Utility Provider' },
    {
      dataField: 'id',
      text: 'Actions',
      formatter: (_cell, row) => (
        <>
          <FontAwesomeIcon
            icon={faSyncAlt}
            style={styles.repullStyle}
            title={'Repull account statements'}
            onClick={() => handleRepullAccount(row.id)}
          />
          {row.utility_template && (
            <>
              {row.utility_template.custom_template_id &&
                templates.find(
                  (template) =>
                    template.id === row.utility_template.custom_template_id
                )
                ? templates.find(
                  (template) =>
                    template.id === row.utility_template.custom_template_id
                ).name
                : 'Preformed Template '}
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={styles.cancelStyle}
                title={'Remove template'}
                onClick={() => handleUnlinkAccount(row.id)}
              />
            </>
          )}
          {!row.utility_template && (
            <>
              <FontAwesomeIcon
                icon={faPlus}
                style={styles.buttonIcon}
                title='Add template'
                onClick={() => handleOpenAddModal(row.id)}
              />
            </>
          )}
        </>
      ),
    },
  ];

  return (
    <div style={{ marginTop: '1em' }}>
      <EnergyTracerTable
        is_masked_child
        data={sortBy(localUtilityAccounts.filter((acc) => !acc.is_masked_child), [
          'account_type',
          'account_number',
          'utility_provider',
        ])}
        columns={tableColumns}
      />

      <LinkCustomPlugTemplateModel
        show={showAddModal}
        onHide={handleOnHide}
        organizationId={organizationId}
        utility_account_id={addAccountId}
        templates={templates}
        setLocalUtilityAccounts={setLocalUtilityAccounts}
        showToast={showToast}
      />
      <ConfirmationModal {...confirmationModalProps} confirmText={'Unlink'} />
      <ConfirmationModal
        {...confirmationModalProps2}
        confirmText={'Refresh'}
        submitVariant={'success'}
      />
    </div>
  );
}
